import { HStack, Spacer, VStack, XButton, XDropZone, XInput, XText } from "IZOX/_X";
import QFButton from "IZOX/BLOCKS/Libs/QForm/QFButton";
import QTable from "IZOX/BLOCKS/Libs/QTable/QTable";
import { ColorX, GFunc, LocaleX } from "IZOX/STATIC";
import { MdCloudUpload, MdCreateNewFolder, MdRefresh } from "react-icons/md";
import AddFolderPopup from "./_gears/AddFolderPopup";
import _ from "lodash";
import { VscRootFolderOpened } from "react-icons/vsc";
import { FaChevronRight, FaFolderOpen } from "react-icons/fa";
import RenameFolderPopup from "./_gears/RenameFolderPopup";
import RenameFilePopup from "./_gears/RenameFilePopup";
import { useCallback, useEffect, useRef, useState } from "react";
import qfileexplorer from "./_schema/qfileexplorer";
import { v1 } from "uuid";
import QFQUICK from "../QForm/QFQUICK";

function QFileExplorer({
  docs,
  totalRows, 
  schema = qfileexplorer,
  onPageChange,
  onPageSizeChange,
  onFilterApply,
  onFilterReset,
  activeSwitch = true,
  onlyActive,
  onOnlyActiveChange,
  inServerSideFilter,
  darkMode,
  onRowSelected,
  onAddFolder,
  onAddFile,
  onRenameFolder,
  onDeleteFolder,
  onRestoreFolder,
  onRenameFile,
  onDeleteFile,
  onRestoreFile,
  onDownloadFile,
  canOperate,
  canEdit,
  canBulkUpload,
  curFolder,
  parentFolders,
  onFolderChange,
  loading,
  acceptFileTypes,
  onUploadFiles,
  multipleUpload,
  onSetDrag,
  onRowDrop,
  onDropToFolder,
  onDropToPage,
  onRefresh,
  addOns
}){

  const inputRef = useRef(null);
  const MountQTable = useRef(null);
  const [internalLoading, setInternalLoading] = useState(false);

  const GetExtraDocs = useCallback(async () => {
    
  }, []);

  useEffect(() => {
    GetExtraDocs();
  }, [GetExtraDocs]);

  const _addFolder = () => {
    if(!canOperate) return;
    GFunc.Backdrop(() => {
      return <AddFolderPopup 
        onAddFolder={onAddFolder} 
        onCancel={() => GFunc.CloseBackdrop()}/>;
    }, {}, false, true);
  };

  const _selectFolder = (folderID) => {
    if(!canOperate) return;
    onFolderChange(folderID);
  };

  const _renameFolder = (folder) => {
    GFunc.Backdrop(() => {
      return <RenameFolderPopup 
        defaultName={folder?.name}
        onRenameFolder={(foldName) => onRenameFolder?.(folder._id, foldName)} 
        onCancel={() => GFunc.CloseBackdrop()}/>;
    }, {}, false, true);
  };

  const _deleteFolder = (folder) => {
    if(!canOperate) return;
    GFunc.AskConfirm({
      EN: "Are you sure to delete this folder?",
      TC: "確定要刪除此資料夾嗎？"
    }, () => onDeleteFolder?.(folder));
  };

  const _restoreFolder = (folder) => {
    if(!canOperate) return;
    GFunc.AskConfirm({
      EN: "Are you sure to restore this folder?",
      TC: "確定要還原此資料夾嗎？"
    }, () => onRestoreFolder?.(folder, true));
  };

  const _downloadFile = (doc) => {
    if(!canOperate) return;
    onDownloadFile?.(doc);
  };

  const _renameFile = (doc) => {
    GFunc.Backdrop(() => {
      return <RenameFilePopup 
        defaultName={doc?.name}
        onRenameFile={(fileName) => onRenameFile?.(doc._id, fileName)} 
        onCancel={() => GFunc.CloseBackdrop()}/>;
    }, {}, false, true);
  };

  const _deleteFile = (doc) => {
    if(!canOperate) return;
    GFunc.AskConfirm({
      EN: "Are you sure to delete this file?",
      TC: "確定要刪除此檔案嗎？"
    }, () => onDeleteFile?.(doc));
  };

  const _restoreFile = (doc) => {
    if(!canOperate) return;
    GFunc.AskConfirm({
      EN: "Are you sure to restore this file?",
      TC: "確定要還原此檔案嗎？"
    }, () => onRestoreFile?.(doc, true));
  };

  const _onClickUpload = () => {
    if(!canBulkUpload){
      onAddFile?.();
      return;
    }
    inputRef.current.click();
  };

  const _onClickRefresh = () => {
    if(!canOperate) return;
    onRefresh?.();
  };

  const _uploadFiles = (e) => {
    if(!canOperate) return;
    onUploadFiles?.(e?.target?.files);
  };

  const _onSetDrag = (drag) => {
    if(!canOperate) return;
    onSetDrag?.(drag);
  };

  const traverseFileTree = async (entry, currentDir, fileArray, onlyFiles) => {
    return new Promise(async (resolve) => {
      if (entry.isFile) {
        const file = await new Promise((resolve) => entry.file(resolve));
        let refID = v1();
        let {name, type} = file;
          let fileName = name ?? "";
          let ext = `.${fileName?.split(".")?.pop()}`;

        if(acceptFileTypes && acceptFileTypes.includes(ext)){
          currentDir[name] = { type: "file", refID, fileType: type };
          fileArray.push({refID, oriFile: file});
        }

      } else if (entry.isDirectory) {
        onlyFiles.value = false;
        const directoryReader = entry.createReader();
        const dirName = entry.name;
        currentDir[dirName] = { type: "folder", children: {} };

        const entries = await new Promise((resolve) => directoryReader.readEntries(resolve));
        for (let i = 0; i < entries.length; i++) {
          await traverseFileTree(entries[i], currentDir[dirName].children, fileArray, onlyFiles);
        }
      }
      resolve();
    });
  }; 

  const separateFilesAndFolders = async (e) => {
    let items = _.map(e.dataTransfer.items, o => o.webkitGetAsEntry());
    let tree = {};
    let fileArray = [];
    let onlyFiles = {value: true};
    for(const o of items){
      if (o) {
        await traverseFileTree(o, tree, fileArray, onlyFiles);
      }
    }
    return { tree, fileArray, onlyFiles: onlyFiles.value };
  };

  const extractDroppedData = async (e) => {
    setInternalLoading(true);
    let files = e.dataTransfer.files;
    let {tree, fileArray, onlyFiles} = await separateFilesAndFolders(e);
    let isDataTransfer = files.length > 0;
    setInternalLoading(false);
    return {
      files,
      tree, 
      isDataTransfer,
      onlyFiles,
      fileArray
    };
  };

  const _onRowDrop = async (drag, drop, e) => {
    if(!canOperate) return;
    let extra = await extractDroppedData(e);
    onRowDrop?.(drag, drop, extra);
  };


  const _onDropToFolder = async (dest, e) => {
    e.preventDefault();
    let extra = await extractDroppedData(e);
    onDropToFolder?.(dest, extra);
    MountQTable.current?.setSelected([]);
  };

  const _onDropToPage = async (e) => {
    e.preventDefault();
    let extra = await extractDroppedData(e);
    onDropToPage?.(extra);
    MountQTable.current?.setSelected([]);
  };

  /**
   * 
   * @param {*} doc 
   * @param {*} docID 
   * @param {*} addOns 
   * @param {import("IZOX/BLOCKS/Libs/QTable/__typedef/__qtable").rowDragAddOns} param 
   * @returns {import("IZOX/_X/HStack").hstackparams}
   */
  const rowParamsAddOns = (doc, docID, addOns, param) => {
    let {isDragOver, firstHalf} = param;
    let isDragAvailable = doc.type === "folder" && isDragOver;
    if(!firstHalf){
      return {
        bW: 2,
        bStyle: "dashed",
        bColor: ColorX.CSS(isDragAvailable ? "cmBlue" : "transparent")
      };
    }else{
      return {
        bW: [2, 1, 2, 2],
        bColor: [
          ColorX.CSS("transparent"),
          ColorX.CSS("cmBlue", 0.1),
          ColorX.CSS("transparent"),
          ColorX.CSS("transparent")
        ]
      };
    }
  };

  function renderDirRow(){
    return (
      <HStack HAlign="[" spacing={5}>
        <XDropZone direction="H" spacing={5} fitWidthToContent bW={2}
          active={canEdit}
          onDrop={(e) => _onDropToFolder(null, e)} 
          bColor={ColorX.CSS("transparent")}
          paramAddOns={(isDragOver) => {
            if(isDragOver){
              return {
                bColor: ColorX.DayNight({day: "blue", night: "cmBlue"}),
                bStyle: "dashed",
              };
            }
          }}>
          <XButton onPress={() => _selectFolder(null)} pV={5} pH={10}
            notInjectColor>
            <HStack spacing={10}
              >
              <VscRootFolderOpened size={20} color={ColorX.DayNight({day: "cmDarkBlue", night: "dmBtnBlue"})}/>
              <XText bold color={ColorX.DayNight({day: "cmDarkBlue", night: "dmBtnBlue"})}>
                {LocaleX.Parse({
                  EN: "Gambot2",
                  TC: "Gambot2"
                })}
              </XText>
            </HStack>
          </XButton>
        </XDropZone>
        
        {_.map(parentFolders, (o, i) => {
          return (
            <HStack key={i} fitWidthToContent spacing={5}>
              <FaChevronRight size={15} color={ColorX.DayNight({day: "cmDarkBlue", night: "dmBtnBlue"})}/>
              <XDropZone direction="H" spacing={5} fitWidthToContent bW={2}
                active={canEdit}
                onDrop={(e) => _onDropToFolder(o._id, e)}
                bColor={ColorX.CSS("transparent")}
                paramAddOns={(isDragOver) => {
                  if(isDragOver){
                    return {
                      bColor: ColorX.CSS("blue"),
                      bStyle: "dashed",
                    };
                  }
                }}>
                <XButton onPress={() => _selectFolder(o._id)} pV={5} pH={10}
                  notInjectColor>
                  <HStack spacing={10}>
                    <FaFolderOpen size={20} color={ColorX.DayNight({day: "cmDarkBlue", night: "dmBtnBlue"})}/>
                    <XText bold color={ColorX.DayNight({day: "cmDarkBlue", night: "dmBtnBlue"})}>
                      {LocaleX.Parse(o.name)}
                    </XText>
                  </HStack>
                </XButton>
              </XDropZone>
            </HStack>
          );
        })}
      </HStack>
    );
  }

  function renderOperRow(){
    return (
      <HStack fullWidth HAlign="[" spacing={5} pH={5}>
        {activeSwitch &&
          QFQUICK.CheckCircle({
            EN: "Hide deleted",
            TC: "隱藏已刪除"
          }, onlyActive, (name, v) => onOnlyActiveChange(v))
        }
        {QFButton.Simple(_addFolder, {
          EN: "Add Folder",
          TC: "新增資料夾",
        }, <MdCreateNewFolder/>, {disabled: !canOperate || !canEdit})}
        <Spacer/>
        {QFButton.Simple(_onClickRefresh, {
          EN: "Refresh",
          TC: "刷新",
        }, <MdRefresh/>, {disabled: !canOperate})}
        {QFButton.Simple(_onClickUpload, {
          EN: "Upload Files",
          TC: "上傳檔案",
        }, <MdCloudUpload/>, {disabled: !canOperate || !canEdit})}
      </HStack>
    );
  }

  return (
    <VStack fullWidth fullHeight bW={1} round={5} p={3}
      bColor={ColorX.CSS("blue")}>
      <XDropZone bW={2} fullWidth fullHeight spacing={5}
        active={canEdit}
        onDrop={(e) => _onDropToPage(e)}
        bColor={ColorX.CSS("transparent")}
        paramAddOns={(isDragOver) => {
          if(isDragOver){
            return {
              bColor: ColorX.CSS("blue"),
              bStyle: "dashed",
            };
          }
        }}>
        {renderDirRow()}
        {renderOperRow()}
        <XInput type="file" onChange={e => _uploadFiles(e)} forwardRef={inputRef}
          noDisplay accept={acceptFileTypes} multiple={multipleUpload}/>
        <QTable
          onMounted={(ref) => MountQTable.current = ref}
          headerHeight={30}
          rowHeight={40}
          selectBox
          showFilterOnLoad
          serverSidePagination
          serverSideFiltering
          fullWidth
          flexGrow={1}
          docs={docs}
          totalRows={totalRows}
          schema={schema}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterApply={onFilterApply}
          onFilterReset={onFilterReset}
          inServerSideFilter={inServerSideFilter}
          darkMode={darkMode}
          onRowSelected={onRowSelected}
          addOns={{
            selectFolder: _selectFolder,
            downloadFile: _downloadFile,
            deleteFile: _deleteFile,
            restoreFile: _restoreFile,
            renameFile: _renameFile,
            renameFolder: _renameFolder,
            deleteFolder: _deleteFolder,
            restoreFolder: _restoreFolder,
            canEdit: canEdit,
            ...addOns
          }}
          loading={loading || internalLoading}
          dragableRow={canEdit}
          droppableRow={canEdit}
          onSetDrag={_onSetDrag}
          onRowDrop={_onRowDrop}
          rowParamsAddOns={rowParamsAddOns}
          />
      </XDropZone>
    </VStack>
  );

}

export default QFileExplorer;